export default "__VITE_ASSET__B563SCm8__"